const emailRe = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const validateEmail = email => emailRe.test(email)

// Have to use !! to cast to boolean because && is doing a short circuit assignment
const validatePassword = pass =>
  !!(pass.length >= 8 && pass.match(/[a-z]/i) && pass.match(/[0-9]/i))

const validatePhone = number => {
  return number.length === 10
}

const notZero = number => {
  return !isNaN(number) && number > 0
}

const notEmpty = text => {
  return !!(text && text.toString().trim() !== "")
}

const validateZip = number => {
  return /^[0-9]{5}(?:[-\s][0-9]{4})?$/.test(number)
}

const validateHeight = height => {
  if ((height.feet === undefined && height.inches === undefined) || height.cm === 0) return false
  return (height.feet !== 0 || height.inches !== 0)
}

export const validateAge = (day, month, year, age) => {
  if (!day || !month || !year || !age) return false

  let today = new Date()

  // if it's the year they turn that age, compare month
  if (year + age === today.getFullYear()) {
    // if it's the month they turn that age, compare day
    if (month === today.getMonth() + 1) {

      // valid if day of date has already passed, or is today
      return day <= today.getDate()
    }

    // valid if month of date has already passed
    return (month < today.getMonth() + 1)
  }

  // valid if year of date has already passed
  return (year + age < today.getFullYear())
}

export const basicFieldsState = {
  sex: {
    error: "Required",
    value: "",
    edited: false,
    valid: false,
    isActive: false,
    validate: notEmpty,
  },
  month: {
    error: "Required",
    value: "",
    edited: false,
    valid: false,
    isActive: false,
    validate: notEmpty,
  },
  day: {
    error: "Required",
    value: "",
    edited: false,
    valid: false,
    isActive: false,
    validate: notEmpty,
  },
  year: {
    error: "Required",
    value: "",
    edited: false,
    valid: false,
    isActive: false,
    validate: notEmpty,
  },
  first: {
    error: "Required",
    value: "",
    edited: false,
    valid: false,
    isActive: false,
    regex: /[^A-Za-z-]/g,
    validate: notEmpty,
  },
  last: {
    error: "Required",
    value: "",
    edited: false,
    valid: false,
    isActive: false,
    regex: /[^A-Za-z-]/g,
    validate: notEmpty,
  },
}

const birthdayFieldState = {
  birthday: {
    valid: false,
    error: false,
    edited: false,
    validate: validateAge,
  }
}

export const profileFieldsState = {
  ...basicFieldsState,
  weight: {
    error: "Required",
    value: undefined,
    edited: false,
    valid: false,
    isActive: false,
    unit: "lbs",
    validate: notZero,
  },
  height: {
    error: "Height cannot be 0",
    value: {
      feet: undefined,
      inches: undefined,
      cm: undefined,
    },
    edited: false,
    valid: false,
    isActive: false,
    unit: "ft/in",
    validate: validateHeight,
  },
}

export const initialProfileState = {
  isEditing: false,
  saved: false,
  disabled: false,
  ...profileFieldsState,
  ...birthdayFieldState,
}

export const initialAccountState = {
  ...basicFieldsState,
  email: {
    error: "Required",
    value: "",
    edited: false,
    valid: false,
    isActive: false,
    validate: validateEmail,
  },
  phone: {
    error: "Invalid phone number",
    value: "",
    edited: false,
    valid: false,
    isActive: false,
    validate: validatePhone,
  },
  password: {
    error: "Minimum 8 characters with one number",
    value: "",
    edited: false,
    valid: false,
    isActive: false,
    validate: validatePassword,
  },
  passwordConfirm: {
    error: "Password must match",
    value: "",
    edited: false,
    valid: false,
    isActive: false,
    validate: validatePassword,
  },
}

export const toolTipText = {
  sex:
    "We recognize that not everyone identifies as female or male. We’re working to incorporate more gender identities into Buoy’s algorithm. For now, enter your sex at birth.",
  race: 
    "Your race and genetic background can influence your health and make you more or less likely to have certain medical conditions.",
}

export const teleMedicineAccountState = {
  ...initialAccountState,
  address1: {
    error: "Required",
    value: "",
    edited: false,
    valid: false,
    isActive: false,
    validate: notEmpty,
  },
  address2: {
    error: "",
    value: "",
    edited: false,
    valid: true,
    isActive: false,
    validate: () => true,
  },
  locality: {
    error: "Required",
    value: "",
    edited: false,
    valid: false,
    isActive: false,
    validate: notEmpty,
  },
  admin_level1: {
    error: "Required",
    value: "",
    edited: false,
    valid: false,
    isActive: false,
    validate: notEmpty,
  },
  postal_code: {
    error: "Invalid zip code",
    value: "",
    edited: false,
    valid: false,
    isActive: false,
    validate: validateZip,
  },
}



// WEBPACK FOOTER //
// ./assets/account/components/UserDetailsFormConfig.js